import {useEffect, useState} from "react";
import {findItemsWithPagination} from "../api/itemApiClient";

export const useItems = (itemCategoryId, itemPropertyValueIds, page, pageSize, reloadTrigger) => {
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState(null);
    const itemPropertyValueIdsKey = JSON.stringify(itemPropertyValueIds || []);

    useEffect(() => {
        const abortController = new AbortController();
        const itemsWithPagination = findItemsWithPagination(page, pageSize, itemCategoryId, itemPropertyValueIds, abortController.signal);

        itemsWithPagination
            .then(
                (data) => {
                    const items = data.items;
                    const pagination = data.pagination;

                    setItems(items)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemCategoryId, itemPropertyValueIdsKey, page, pageSize, reloadTrigger]);

    return {items : items, pagination};
};
